export default __webpack_public_path__ + "static/media/grayborder.707aa598.svg";